export const styles = (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  dialogPaper: {
    minHeight: "400px",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  multiSelector: {
    backgroundColor: "#fff",
    "z-index": 10,
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  tabStyle: {
    borderBottom: "1px solid rgba(0,0,0,.1)"
  },
  tabContent: {
    padding: 0
  },
  noticeShort: {
    backgroundColor: "#F3F3F3",
    padding: theme.spacing(4)
  },
  mutedText: {
    fontSize: "1rem",
    fontWeight: 400,
    color: "rgba(0, 0, 0, 0.54)"
  }
});